// WhatsApp Configuration Constants
export const WHATSAPP_AI_AGENT_NUMBER = '15558410313';

// WhatsApp AI Agent Configuration
export const WHATSAPP_CONFIG = {
  agentNumber: WHATSAPP_AI_AGENT_NUMBER,
  agentNumberWithPlus: `+${WHATSAPP_AI_AGENT_NUMBER}`,
  whatsappUrl: `https://wa.me/${WHATSAPP_AI_AGENT_NUMBER}`,
  verifyUrl: `https://wa.me/${WHATSAPP_AI_AGENT_NUMBER}?text=verify-agent-unknown`,
} as const;